/** @file puppetInverse: the fallback inverse that re-imports the whole puppet as it was (plan inverse P). */
import type { PuppetDoc } from '../puppetDoc/puppetDoc';
import type { Command } from '../types/command';

/** `[puppet.import { doc: <puppet now> }]`; call it before mutating the draft. */
export function puppetInverse(draft: PuppetDoc): Command[] {
  return [{ name: 'puppet.import', input: { doc: structuredClone(draft.puppet) } }];
}
